export default __webpack_public_path__ + "static/media/add-white.fbfd6885.svg";